import _ from "lodash"

import {
  CurrentPermissionState,
  PermissionFlag,
  TourFieldPermissions,
} from "@/onboarding/features/bidding/types"

export const tourPermissionValue = (
  tour: TourFieldPermissions,
  fieldName: string,
  permissionFlag: PermissionFlag
): boolean | undefined => {
  if (permissionFlag === PermissionFlag.WRITEABLE) {
    if (tour.fieldsLockedOnSomeDocuments.includes(fieldName)) {
      return undefined
    }

    return !tour.fieldsLockedOnEveryDocument.includes(fieldName)
  }

  if (tour.fieldsRequiredOnSomeDocuments.includes(fieldName)) {
    return undefined
  }

  return tour.fieldsRequiredOnEveryDocument.includes(fieldName)
}

export const currentPermissionState = (
  tours: TourFieldPermissions[],
  fieldName: string,
  permissionFlag: PermissionFlag
): CurrentPermissionState => {
  const values = _.uniq(tours.map((tour) => tourPermissionValue(tour, fieldName, permissionFlag)))

  const mixed = values.length > 1 || values.includes(undefined)

  return { value: mixed ? undefined : values[0], mixed }
}

export const changedTours = (
  tours: TourFieldPermissions[],
  fieldName: string,
  permissionFlag: PermissionFlag,
  pickedPermissionValue: boolean | undefined
): TourFieldPermissions[] => {
  if (pickedPermissionValue === undefined) {
    return []
  }

  return tours.filter(
    (tour) => tourPermissionValue(tour, fieldName, permissionFlag) !== pickedPermissionValue
  )
}
